<div class="source-name-cell-container">
  <local-seo-source-name-icon [name]="element.name" [iconUrl]="element.sourceIcon"></local-seo-source-name-icon>
  <div class="link-text">
    <div class="link-source-name-text">{{ element.name }}</div>

    @if (!!element.listingUrl && element.isSyncingEnabled) {
      <a [href]="element.listingUrl" target="_blank">
        <div class="link-view-listing-text">
          {{ 'LISTING_SYNC.TABLE_LABEL.VIEW_SOURCE' | translate }}
        </div>
      </a>
    }
  </div>
</div>
